export class Paths {
    static readonly getDisplaySettings = "/System/GetDisplaySettings";
    static readonly getSchoolImagePath = "/School/GetSchoolImage?param=";
    static readonly getSchoolPath = "/School/GetSchool";
    static readonly getAllSchoolsPath = "/School/GetAllSchools";
    static readonly getAllSchoolsDirectoryPath = "/School/GetAllSchoolsForDirectory";
    static readonly updateDisplaySettings = "/System/UpdateDisplaySettings";
    static readonly getAllSchoolsForAdminPath = "/School/GetAllSchoolsForAdmin";
    static readonly UpdateSchoolsForAdmin = "/School/UpdateSchoolsForAdmin"
    static readonly getIsAdmin = "/System/GetIsAdmin";
    static readonly getSettings = "/System/Settings";
    static readonly getDisplaySettingsForAdmin = '/System/GetDisplaySettingsForAdmin'
}